import { combineReducers } from "redux";
import { InstantState } from "./state";
import { agendaInstantsReducer } from "../usecases/loadAgendaInstants/loadAgendaInstants.reducer";

export const InstantRootReducer = combineReducers<InstantState>({
    agenda: agendaInstantsReducer
})
